import { SubmitHandler } from 'react-hook-form';
import { useNavigate } from "react-router";
import useCreateRestaurant from '../../hooks/Restaurant/useCreateRestaurant'
import RestaurantForm from "./RestaurantForm";
import { useToast } from "../../context/ToastContext";
import { isString } from 'lodash';

import type { RestaurantVariables } from '../../types/restaurantTypes';

const RestaurantNew = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { createRestaurant } = useCreateRestaurant({
    onCompleted: (restaurantCreated) => {
      if (restaurantCreated) {
        navigate('/restaurants');
        toast.success(`Restaurant ${restaurantCreated.name} created successfully`);
      }
    },
    onError: (err) => {
      if (err) return toast.error(String(err)); 
    }
  });

  const onSubmit: SubmitHandler<RestaurantVariables> = async formValues => {
    if (isString(formValues.address)) {
      return toast.error('Please select address from list.');
    }
    try {
      await createRestaurant({
        phone: formValues.phone,
        website: formValues.website,
        wifi: formValues.wifi,
        name: formValues.name,
        image: formValues.image instanceof FileList ? formValues.image[0] : formValues.image,
        address: {
          fullAddress: formValues.address.fullAddress,
          latitude: formValues.address.latitude,
          longitude: formValues.address.longitude,
          street: formValues.address.street,
          house: formValues.address.house,
          countryCode: formValues.address.countryCode,
          mapboxId: formValues.address.mapboxId
        }
      });
    } catch (err) {
      console.error("restaurant create error (component):", err);
      // toast
    }
  };

  return <RestaurantForm onSubmit={onSubmit} />
}

export default RestaurantNew;
